























import Vue from 'vue';
import { Membership } from '~/services/CandidateService';
import { commonProps } from '~/utils/candidate';

// Components
import Card from './Card.vue';
import MembershipListItem from '../components/MembershipListItem.vue';
import MembershipModal from '../modals/MembershipModal.vue';

export default Vue.extend({
    name: 'Membership',
    components: { Card, MembershipModal, MembershipListItem },
    props: {
        ...commonProps(),
    },
    data() {
        return {
            showModal: false,
        };
    },
    computed: {
        memberships(): Membership[] {
            const we = this.candidate.memberships;
            we.sort((a, b) => {
                return b.start.getTime() - a.start.getTime();
            });
            return we;
        },
        hasNoMemberships(): boolean {
            return !this.candidate.memberships.length;
        },
        cardTitle(): string {
            return this.hasNoMemberships
                ? this.$t('profile.memberships.titleWhenEmpty').toString()
                : this.$t('profile.memberships.title').toString();
        },
    },
});
